<table htm-table>
  <tr>
    <td>{{ 'school.register_code_short' | translate }}</td>
    <td>{{ data.fieldRegistrationCode }}</td>
  </tr>

  @if (data.fieldOwnershipType?.length) {
    <tr>
      <td>{{ 'school.ownership' | translate }}</td>
      <td>{{ data.fieldOwnershipType[0] | titlecase }}</td>
    </tr>
  }
  @if (data.teachingLanguage?.length) {
    <tr>
      <td>{{ 'school.language' | translate }}</td>
      <td>
        @for (language of data.teachingLanguage; track language) {
          <div>
            {{ language | titleCase }}
          </div>
        }
      </td>
    </tr>
  }
  @if (data.specialClass) {
    <tr>
      <td>{{ 'school.special_needs_long' | translate }}</td>
      <td>
        <span>{{ 'school.available' | translate | titlecase }}</span>
      </td>
    </tr>
  }
  @if (data.studentHome) {
    <tr>
      <td>{{ 'school.dormitory' | translate }}</td>
      <td>
        <span>{{ 'school.available' | translate | titlecase }}</span>
      </td>
    </tr>
  }
</table>
